import React from 'react';
import './SecureCheckoutLabel.css';

export default function SecureCheckoutLabel({ showCards = true }) {
  return (
    <div className="secureCheckoutLabel">
      {showCards ? (
        <picture>
          <source media="(min-width: 650px)" srcSet="/account/static/images/cards/secure-checkout-01.png" />
          <source media="(min-width: 465px)" srcSet="/account/static/images/cards/secure-checkout-small-01.png" />
          <img
            className="secureCheckout"
            src="/account/static/images/cards/secure-checkout-small-01.png"
            alt="secure checkout"
          />
        </picture>
      ) : (
        <img
          className="secureCheckout safeCheckout"
          src="/account/static/images/cards/safe-checkout-green.png"
          alt="secure checkout"
        />
      )}
    </div>
  );
}
